export default __webpack_public_path__ + "static/media/sellers.0f06b14f.svg";